"use strict";

exports.__esModule = true;
exports.AggregateTimelineMetricQueryController = void 0;
var _react = _interopRequireDefault(require("react"));
var _APIQueryController = require("../../API/APIQueryController");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AggregateTimelineMetricQueryController = exports.AggregateTimelineMetricQueryController = function AggregateTimelineMetricQueryController(props) {
  var query = props.query,
    children = props.children;
  return /*#__PURE__*/_react["default"].createElement(_APIQueryController.APIQueryController, {
    url: "/api/v3/timeseries-metrics/flattened",
    method: "POST",
    body: query
  }, children);
};